export const pattern21Data = [
  {
    koreanChunks: ["우리는 받았다 어떤 보고서 하나를", "마케팅팀으로부터 어제"],
    englishChunks: [
      "We received a report",
      "from the marketing team yesterday",
    ],
    fullEnglish: "We received a report from the marketing team yesterday.",
    additionalExplanation:
      "원어민들은 특정하지 않은 것, 처음 언급하는 것들을 말할 때 a/an을 사용합니다",
  },
  {
    koreanChunks: ["그 보고서는 포함한다", "자세한 고객 피드백을"],
    englishChunks: ["The report includes", "detailed customer feedback"],
    fullEnglish: "The report includes detailed customer feedback.",
    additionalExplanation:
      "이미 언급된 특정 보고서를 가리킬 때는 'the'를 사용합니다.",
  },
  {
    koreanChunks: [
      "당신은 상담해야 합니다 관리자와",
      "만약 당신이 가진다면 우려사항들을",
    ],
    englishChunks: ["You should consult", "a manager", "if you have concerns"],
    fullEnglish: "You should consult a manager if you have concerns.",
    additionalExplanation:
      "여기서 'a manager'는 특정되지 않은 관리자를 의미합니다. 불특정 단수 명사 앞에는 부정관사 a/an을 사용합니다. 'concerns'는 복수형으로 사용되어 '우려사항들'을 나타냅니다.",
  },
  {
    koreanChunks: ["당신은 말해야 합니다", "관리자에게 당신 부서"],
    englishChunks: ["You should speak", "to the manager of your department"],
    fullEnglish: "You should speak to the manager of your department.",
    additionalExplanation:
      "여기서 'the manager'는 특정 부서의 관리자라는 특정 대상을 가리키므로 정관사 'the'를 사용합니다.",
  },
  {
    koreanChunks: ["이 청구서는 포함합니다", "연체료를"],
    englishChunks: ["This invoice includes", "a late payment fee"],
    fullEnglish: "This invoice includes a late payment fee.",
    additionalExplanation:
      "This는 특정 청구서를 가리킬 때 사용합니다. 청구서가 단수라 this가 옵니다.",
  },
  {
    koreanChunks: ["그 결정은 내려졌다", "이사회에 의해 지난 분기에"],
    englishChunks: ["That decision was made", "by the board last quarter"],
    fullEnglish: "That decision was made by the board last quarter.",
    additionalExplanation:
      "That을 써서 결정이 아무 결정이 아닌 그 결정이라고 한정할 수 있습니다. 결정이 단수기에 단수형이 왓습니다.",
  },
  {
    koreanChunks: ["이 서류들은", "제출되어야 합니다", "금요일 전에"],
    englishChunks: ["These documents", "must be submitted", "before Friday"],
    fullEnglish: "These documents must be submitted before Friday.",
    additionalExplanation:
      "'These'는 복수 지시형용사로, 가까이 있는 복수 명사를 가리킬 때 사용합니다. 'documents'는 복수 명사이므로 'These'와 함께 사용됩니다. '서류들'말고 '이 서류들'로 한정하고 싶을 때 원어민은 these를 붙입니다.",
  },
  {
    koreanChunks: ["그 결과들은 (과거에)수집되었다", "작년 설문조사에서"],
    englishChunks: ["Those results were collected", "from last year's survey"],
    fullEnglish: "Those results were collected from last year's survey.",
    additionalExplanation:
      "'Those'는 원거리에 있는 복수 명사를 가리키는 지시형용사입니다. 'results'가 복수 명사이므로 'Those'와 함께 사용됩니다. 결과들을 한정하고 싶을 때 그냥 결과들 말고 그 결과들이라고 하고 싶을 때 사용합니다",
  },
  {
    koreanChunks: [
      "팔로우업 해주세요",
      "그 문제에 대해",
      "그... 제기된 회의 중에",
    ],
    englishChunks: [
      "Please follow up on",
      "that issue",
      "raised during the meeting",
    ],
    fullEnglish: "Please follow up on that issue raised during the meeting.",
    additionalExplanation:
      "모든 문제가 아닌 회의 중에 이미 논의된 특정 문제를 말하고 싶을때 that을 붙입니다. 단수라 those가 왔습니다.",
  },
  {
    koreanChunks: ["이 파일들은 (현재)업로드되었습니다", "서버에"],
    englishChunks: ["These files have been uploaded", "to the server"],
    fullEnglish: "These files have been uploaded to the server.",
    additionalExplanation:
      "'These'는 가까이 있는 복수 명사를 가리키는 지시형용사입니다. 'files'가 복수 명사이므로 'These'와 함께 사용됩니다..",
  },
  {
    koreanChunks: [
      "그 회사는 발표했습니다",
      "변경 사항을",
      "그회사의 반품 정책에 대한",
    ],
    englishChunks: ["The company announced", "changes", "to its return policy"],
    fullEnglish: "The company announced changes to its return policy.",
    additionalExplanation:
      "반품 정책이 이 회사의 반품 정책이라고 한정하고 싶지만 반복을 피하기 위해 소유 대명사 its를 사용합니다.",
  },
  {
    koreanChunks: [
      "고객들이 물었습니다 여러 후속 질문들을",
      "고객들의 미팅 이후에",
      "영업팀과의",
    ],
    englishChunks: [
      "The clients asked several follow-up questions",
      "after their meeting with the sales team",
    ],
    fullEnglish:
      "The clients asked several follow-up questions after their meeting with the sales team.",
    additionalExplanation:
      "'their'는 소유 대명사로, 여기서는 '고객들의'를 의미합니다. 고객들이 영업팀과 가진 회의라는 것을 명확히 하기 위해 사용되었습니다.",
  },
];
